import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";

// Components
import Spinner from "../../Components/Loading/Spinner";
import FilterBox from "./Components/FilterBox";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import moment from "moment/moment";

export default function ListOrders() {
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [filtering, setFiltering] = useState(true);
    const [orders, setOrders] = useState([]);
    

    // Load users
    useEffect(() => {
        loadOrders()
    }, []);



    const handleFilter = (form) => {
        loadOrders(form);
    }

    function loadOrders(form) {
        console.log("loading orders...", form);
        var currentDate = new Date();

        setFiltering(true);

        var status = form ? form.status : "";
        var customerId = form ? form.customerId : "";
        var supplierId = form ? form.supplierId : "";
        var agentId = form ? form.agentId : "";
        var orderNo = form ? form.orderNo : "";
        var valueLessThan = form ? form.valueLessThan : "";
        var valueGreaterThan = form ? form.valueGreaterThan : "";
        var dateLessThan = form ? form.dateLessThan : "";
        var dateGreaterThan = form ? form.dateGreaterThan : moment().subtract(1, 'months').format('YYYY-MM-DD');

       


        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/?` +
                    `status=${status}` +
                    `&customerId=${customerId}` +
                    `&supplierId=${supplierId}` +
                    `&agentId=${agentId}` +
                    `&orderNo=${orderNo}` +
                    `&valueLessThan=${valueLessThan}` +
                    `&valueGreaterThan=${valueGreaterThan}` +
                    `&dateLessThan=${dateLessThan}` +
                    `&dateGreaterThan=${dateGreaterThan}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Orders:", res.data);
                setOrders(res.data);
                setLoading(false);
                setFiltering(false);
            })
            .catch((err) => {
                setLoading(false);
                setFiltering(false);

                console.log("response code: ", err.response.status)
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }

                console.log(err);
                
                
                
            });
    }

    return (
        <div className="page">
            <div className="row">
                <div className="col-12" style={{ minHeight: 1000 }}>
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Orders <button className="btn-sm btn-primary" onClick={() => { navigate(`/Orders/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                            <FilterBox filterOrders={handleFilter} />

                            {filtering && (<Spinner />)}
                            {!filtering && (

                                <table style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 120 }}>Order No.</th>
                                            <th style={{ width: 150 }} className="d-none d-md-table-cell">Date</th>
                                            <th>Customer</th>
                                            <th>Agent</th>
                                            <th style={{ width: 100 }}>Status</th>
                                            <th style={{ width: 100 }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>Net Contribution</th>
                                            <th style={{ width: 140 }}>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders && (orders.map((order) => {
                                            return (
                                                <tr key={order.id} style={{ cursor: "pointer" }}>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.id}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{moment(order.dateOrdered).format('DD/MM/YYYY')}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.customer.name} {order.farm && `(${order.farm})`}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.agent.name}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }}>{order.status}</td>
                                                    <td onClick={() => { navigate(`/Orders/View/${order.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{order.totalNetContribution.toFixed(2)}</td>

                                                    <td>
                                                        <Link to={`/Orders/View/${order.id}`} className="btn-sm btn-primary">View</Link>
                                                        <Link to={`/Orders/Edit/${order.id}`} className="btn-sm btn-other">Edit</Link>
                                                    </td>
                                                </tr>
                                            )
                                        }))}

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Total</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{orders.reduce((total, order) => total + order.totalNetContribution, 0).toFixed(2)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
